import { NativeSelect } from "@mui/material";
import { FormizoSchema } from "Components/LabIZO/Formizo";
import { CustomFilterValueProps, FieldType, Filterable, TablizoSchema } from "Components/LabIZO/Tablizo";
import _ from "lodash";

const Table: TablizoSchema[] = [
  {
    label: "Receive Time",
    name: "recTime",
    type: "dateTime",
    transform: "datetime",
    width: 180,
    filterable: true,
    defaultSort: "desc",
  },
  {
    label: "User Display Name",
    name: "userDisplayName",
    filterable: true,
    valueGetter: (_: any, cellVal: any) => cellVal || "N/A",
  },
  {
    label: "Cat",
    name: "cat",
    filterable: true,
  },
  {
    label: "Subcat",
    name: "subcat",
    filterable: true,
  },
  {
    label: "Action",
    name: "action",
    filterable: true,
  },
  {
    label: "IP",
    name: "ip",
    filterable: true,
    width: 120,
  },
  {
    label: "Request Body",
    name: "body",
    sortable: false,
  },
];

const Info: FormizoSchema[] = [
  {
    label: "ID",
    name: "_id",
    validate: ["required"],
    format: "text",
    readOnly: true,
  },
  {
    label: "User Display Name",
    name: "userDisplayName",
    format: "text",
    readOnly: true,
  },
  {
    label: "Cat",
    name: "cat",
    format: "text",
    readOnly: true,
  },
  {
    label: "Subcat",
    name: "subcat",
    format: "text",
    readOnly: true,
  },
  {
    label: "Action",
    name: "action",
    format: "text",
    readOnly: true,
  },
  {
    label: "URL",
    name: "url",
    format: "text",
    readOnly: true,
  },
  {
    label: "Receive Time",
    name: "recTime",
    format: "text",
    readOnly: true,
  },
  {
    label: "Host",
    name: "host",
    format: "text",
    readOnly: true,
  },
  {
    label: "Origin",
    name: "origin",
    format: "text",
    readOnly: true,
  },
  {
    label: "Referrer",
    name: "referrer",
    format: "text",
    readOnly: true,
  },
  {
    label: "IP",
    name: "ip",
    format: "text",
    readOnly: true,
  },
  {
    label: "Request Body",
    name: "body",
    format: "textarea",
    readOnly: true,
  },
];

const Filterables: Filterable[] = [
  {
    field: "userDisplayName",
    label: "User Display Name",
    type: FieldType.select,
    CustomFilterValue: ({ field, width, fieldState }: CustomFilterValueProps) => (
      <NativeSelect {...field} sx={{ width: width }} error={Boolean(fieldState?.error)}>
        <option value={""}></option>
        <option value={"SYVA Demo"}>SYVA Demo</option>
        <option value={"SYVA Super Admin"}>SYVA Super Admin</option>
      </NativeSelect>
    ),
  },
  {
    field: "cat",
    label: "Cat",
    type: FieldType.text,
  },
  {
    field: "subcat",
    label: "Subcat",
    type: FieldType.text,
  },
  {
    field: "action",
    label: "Action",
    type: FieldType.text,
  },
  {
    field: "ip",
    label: "IP",
    type: FieldType.text,
  },
];

const Export = [
  {
    Header: "ID",
    accessor: "_id",
  },
  {
    Header: "User Display Name",
    accessor: "userDisplayName",
  },
  {
    Header: "Subcat",
    accessor: "subcat",
  },
  {
    Header: "Action",
    accessor: "action",
  },
  {
    Header: "URL",
    accessor: "url",
  },
  {
    Header: "Receive time",
    accessor: "recTime",
  },
  {
    Header: "Host",
    accessor: "host",
  },
  {
    Header: "Origin",
    accessor: "origin",
  },
  {
    Header: "Referrer",
    accessor: "referrer",
  },
  {
    Header: "IP",
    accessor: "ip",
  },
  {
    Header: "Request Body",
    accessor: "body",
  },
];

const AdvFilter: any = [];

const schema: any = {
  Table,
  Info,
  Export,
  AdvFilter,
  Filterables,
};

export default schema;
